export const doorTypes = [
    { value: null, text: 'Keine Eigenschaft definiert' },
    { value: 'OPEN', text: 'Permanent offener Durchgang (bauseitig keine Tür)' },
    { value: '4.0', text: 'Verbrennungsluftöffnung mit min. 150cm² freier Querschnitt' },
    { value: '4.1', text: 'Verbrennungsluftöffnung mit 2x 150cm² freier Querschnitt' },
    { value: '1.0', text: '3-seitig umlaufende Dichtung; ungekürztes Türblatt' },
    { value: '2.0', text: '3-seitig umlaufende Dichtung; 1cm gekürztes Türblatt' },
    { value: '3.0', text: '3-seitig umlaufende Dichtung; 1,5cm gekürztes Türblatt' },
    { value: '2.1', text: 'Ohne umlaufende Dichtung; ungekürztes Türblatt' },
    { value: '3.1', text: 'Ohne umlaufende Dichtung; 1cm gekürztes Türblatt' },
    { value: '2.2', text: 'Überstromdichtung; ungekürztes Türblatt' },
    { value: '3.2', text: 'Überstromdichtung; 1cm gekürztes Türblatt' }
]
